module.exports = __webpack_public_path__ + "static/media/plantPal2_03.855d87b0.gif";